import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "noResults"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Added items will appear here.", -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(_ctx.$style.searchResults)
  }, [
    (!$props.results.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($props.results, (result) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(_ctx.$style.results)
          }, [
            (_openBlock(), _createBlock($setup["ListItem"], {
              result: result,
              key: result.id,
              matches: $props.highlight === result.id,
              onDelete: _cache[0] || (_cache[0] = (id) => _ctx.$emit('deleteItem', id))
            }, null, 8, ["result", "matches"]))
          ], 2))
        }), 256))
  ], 2))
}